import React from 'react'
import cx from 'classnames'
import './CloseBtn2.css'

import RGlow3 from '../../components/Svg/radial-glow-3'
import { ToBack } from '../../components/Svg';

export default ({onClick, onMouseEnter, className, ...props}) => {

    return (
        <div
            className={cx("btn btn-close hud__close close-btn", className)}
            onClick={typeof onClick !== 'undefined' && onClick}
            onMouseEnter={typeof onMouseEnter !== 'undefined' && onMouseEnter}
        >
            <div className="btn__icon"><ToBack/></div>
            <div className="btn__circles">
            </div>
            <div className="btn__glow">
                <RGlow3/>
            </div>
        </div>
    )
}
